<div class="wrapper" [class.standalone]="standalone">
  <app-home-estimator-dialog *ngIf="!homeEstimate"
                             [homeEstimatorForm]="homeEstimatorForm"
                             [suggestions]="suggestions"
                             (onSuggestionClick)="getEstimateForSuggestion($event)"
                             (onSuggestionsClose)="closeSuggestions()"
                             [hasError]="hasError"
                             [standalone]="standalone"
                             (onSubmit)="getEstimate()">
  </app-home-estimator-dialog>
  <app-home-estimator-estimate *ngIf="homeEstimate"
                               [homeEstimate]="homeEstimate"
                               [homeEstimatorRequest]="homeEstimatorRequest"
                               (onContactAgent)="onContactAgent.emit()"
                               [standalone]="standalone"
                               (onEdit)="editForm()">
  </app-home-estimator-estimate>
</div>
